import './TextArea.scss';
import clsx from 'clsx';
import React, { memo, DetailedHTMLProps, ReactNode, TextareaHTMLAttributes } from 'react';
import { ErrorIcon } from 'src/modules/common/icons/ErrorIcon';

type TextAreaAttributes = DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;

export type TextAreaProps = Omit<TextAreaAttributes, 'ref'> & {
  readonly theme?: 'white' | 'gray';
  readonly label?: ReactNode;
  readonly invalid?: boolean;
  readonly invalidText?: ReactNode;
  readonly description?: ReactNode;
  readonly actions?: ReactNode;
};

export const TextArea = memo(({
  label,
  description,
  invalid,
  invalidText,
  theme = 'gray',
  actions,
  ...props
}: TextAreaProps) => {
  const helperText = invalid ? invalidText || description : description;

  return (
    <div className="bp-textarea">
      {label && (
        <div className={clsx({
          'bp-textarea__label': true,
          'bp-textarea__label--disabled': props.disabled,
        })}
        >
          {label}
        </div>
      )}

      <div className="bp-textarea__wrapper">
        <textarea
          {...props}
          className={clsx({
            'bp-textarea__input': true,
            'bp-textarea__input--invalid': invalid,
            'bp-textarea__input--readonly': props.readOnly,
            [`bp-textarea__input--${theme}`]: true,
          })}
        />

        <div className="bp-textarea__end-adornment">
          {invalid && (
            <div className="bp-textarea__error-icon">
              <ErrorIcon/>
            </div>
          )}

          {actions}
        </div>
      </div>

      {helperText && (
        <div className={clsx({
          'bp-textarea__description': true,
          'bp-textarea__description--disabled': props.disabled,
          'bp-textarea__description--invalid': invalid,
        })}
        >
          {helperText}
        </div>
      )}
    </div>
  );
});
